function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  d: "M21.79 11.54a1 1 0 0 0-1.15.42A5.5 5.5 0 0 1 10.51 9a5.53 5.53 0 0 1 4-5.28 1 1 0 0 0-.06-1.93 10.5 10.5 0 1 0 8.07 10.76 1 1 0 0 0-.73-1.01zM12 20.5a8.5 8.5 0 0 1-1.16-16.92 7.5 7.5 0 0 0 8.91 11.93A8.5 8.5 0 0 1 12 20.5z"
});

var _ref2 =
/*#__PURE__*/
React.createElement("text", {
  y: 39,
  fontSize: 5,
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "Created by Martin");

var _ref3 =
/*#__PURE__*/
React.createElement("text", {
  y: 44,
  fontSize: 5,
  fontWeight: "bold",
  fontFamily: "'Helvetica Neue', Helvetica, Arial-Unicode, Arial, Sans-serif"
}, "from the Noun Project");

var SvgNounMoon2148355 = function SvgNounMoon2148355(props) {
  return React.createElement("svg", _extends({
    "data-name": "Warstwa 1",
    viewBox: "0 0 24 30"
  }, props), _ref, _ref2, _ref3);
};

export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIGRhdGEtbmFtZT0iV2Fyc3R3YSAxIiB2aWV3Qm94PSIwIDAgMjQgMzAiIHg9IjBweCIgeT0iMHB4Ij48dGl0bGU+V2VhdGhlcjwvdGl0bGU+PHBhdGggZD0iTTIxLjc5LDExLjU0YTEsMSwwLDAsMC0xLjE1LjQyQTUuNSw1LjUsMCwwLDEsMTAuNTEsOWE1LjUzLDUuNTMsMCwwLDEsNC01LjI4LDEsMSwwLDAsMC0uMDYtMS45MywxMC41LDEwLjUsMCwxLDAsOC4wNywxMC43NkExLDEsMCwwLDAsMjEuNzksMTEuNTRaTTEyLDIwLjVBOC41LDguNSwwLDAsMSwxMC44NCwzLjU4YTcuNSw3LjUsMCwwLDAsOC45MSwxMS45M0E4LjUsOC41LDAsMCwxLDEyLDIwLjVaIi8+PHRleHQgeD0iMCIgeT0iMzkiIGZpbGw9IiMwMDAwMDAiIGZvbnQtc2l6ZT0iNXB4IiBmb250LXdlaWdodD0iYm9sZCIgZm9udC1mYW1pbHk9IidIZWx2ZXRpY2EgTmV1ZScsIEhlbHZldGljYSwgQXJpYWwtVW5pY29kZSwgQXJpYWwsIFNhbnMtc2VyaWYiPkNyZWF0ZWQgYnkgTWFydGluPC90ZXh0Pjx0ZXh0IHg9IjAiIHk9IjQ0IiBmaWxsPSIjMDAwMDAwIiBmb250LXNpemU9IjVweCIgZm9udC13ZWlnaHQ9ImJvbGQiIGZvbnQtZmFtaWx5PSInSGVsdmV0aWNhIE5ldWUnLCBIZWx2ZXRpY2EsIEFyaWFsLVVuaWNvZGUsIEFyaWFsLCBTYW5zLXNlcmlmIj5mcm9tIHRoZSBOb3VuIFByb2plY3Q8L3RleHQ+PC9zdmc+";
export { SvgNounMoon2148355 as ReactComponent };